import { useTranslation } from 'libs/i18n'
import { useDevice, usePagination } from 'shared/hooks'
import { Table2 } from 'shared/components'
import { Pagination } from 'shared/atoms'
import { getCardTableStyles } from 'styles/table'
import { Booking } from 'features/bookings'
import type { BookingItem, BookingsRes } from 'features/bookings/types/bookings.types'
import type { Option } from 'shared/components/ContextMenu/types'
import type { Select } from '@table-library/react-table-library/select'
import { useColumns } from '../../../hooks/table'

type TableSectionProps = {
	bookings: BookingsRes
	isLoading: boolean
	select: Select
	getMenuOptions: (booking: BookingItem) => Option[]
}

export const TableSection = ({
	bookings,
	isLoading,
	select,
	getMenuOptions
}: TableSectionProps) => {
	const { t } = useTranslation()
	const { isBelowDesktop } = useDevice()
	const { handlePagination } = usePagination()
	const columns = useColumns({ getMenuOptions })

	const results: BookingItem[] = bookings.data.results
	const tableStyles = getCardTableStyles(columns, { clickableRows: false })

	return (
		<>
			{isBelowDesktop ? (
				<ul className="divide-y divide-border lg:min-h-0 lg:flex-1 lg:overflow-y-auto">
					{results.map((booking) => (
						<Booking key={booking.id} booking={booking} menuOptions={getMenuOptions(booking)} />
					))}
				</ul>
			) : (
				<Table2
					className="mb-0 px-0 py-0 lg:flex lg:min-h-0 lg:flex-1 lg:flex-col"
					columns={columns}
					data={{ nodes: results }}
					isLoading={isLoading}
					select={select}
					customStyles={tableStyles}
				/>
			)}
			<div className="flex items-center justify-between gap-3 border-t border-border px-4 py-3 text-[11px] font-medium text-muted-foreground sm:px-5">
				<span>{t('{{ count }} bookings', { count: results.length })}</span>
				<Pagination
					prev={bookings.data.previous}
					next={bookings.data.next}
					onClick={handlePagination}
				/>
			</div>
		</>
	)
}
